/**
 * Ilustración de línea: una paca de papel amarrada, en isométrico simple.
 * Vectorial, sin imágenes — cero peso adicional en la red (unos pocos KB
 * de markup). Dos variantes:
 *  - "line"  → solo contorno, para usarla como marca de agua/acento (hero).
 *  - "full"  → con las caras coloreadas con los tonos reales del stock,
 *              para usarla como ilustración editorial (CTA, divisores).
 */
export default function PaperBale({
    variant = 'line',
    className = '',
    color = 'var(--kraft-deep)',
}) {
    const sheetLines = [102, 122, 142, 162];

    return (
        <svg
            viewBox="0 0 240 220"
            className={className}
            fill="none"
            aria-hidden="true"
        >
            {variant === 'full' && (
                <>
                    {/* Cara frontal */}
                    <path d="M40 80H150V180H40V80Z" fill="var(--stock-canela)" />
                    {/* Cara superior (luz) */}
                    <path d="M40 80L80 50H190L150 80H40Z" fill="var(--stock-mostaza)" />
                    {/* Cara lateral (sombra) */}
                    <path d="M150 80L190 50V150L150 180V80Z" fill="var(--kraft-deep)" />
                </>
            )}

            {/* Contorno de las tres caras */}
            <path
                d="M40 80H150V180H40V80Z M40 80L80 50H190L150 80 M150 80L190 50V150L150 180"
                stroke={variant === 'full' ? 'var(--ink)' : color}
                strokeOpacity={variant === 'full' ? 0.55 : 1}
                strokeWidth="2"
                strokeLinejoin="round"
            />

            {/* Líneas de las hojas apiladas — frente */}
            {sheetLines.map((y) => (
                <line
                    key={`f-${y}`}
                    x1="40" y1={y} x2="150" y2={y}
                    stroke={variant === 'full' ? 'var(--ink)' : color}
                    strokeOpacity={variant === 'full' ? 0.28 : 0.55}
                    strokeWidth="1.25"
                />
            ))}
            {/* Líneas de las hojas apiladas — lateral, en perspectiva */}
            {sheetLines.map((y, i) => (
                <line
                    key={`s-${y}`}
                    x1="150" y1={y} x2="190" y2={y - 30}
                    stroke={variant === 'full' ? 'var(--ink)' : color}
                    strokeOpacity={variant === 'full' ? 0.28 : 0.55}
                    strokeWidth="1.25"
                />
            ))}

            {/* Amarre: dos flejes que envuelven la paca en cruz + nudo */}
            <g stroke={variant === 'full' ? 'var(--ink)' : color} strokeWidth="7" strokeLinecap="round">
                {/* Fleje vertical: sube por el frente, cima y baja por el lateral */}
                <path d="M75 180V80L95 65V50" opacity="0.9" />
                <path d="M95 50L115 65V150L133 165" opacity="0.9" />
                {/* Fleje horizontal: cruza el frente y envuelve el lateral */}
                <path d="M40 130H150" opacity="0.9" />
                <path d="M150 130L190 100" opacity="0.9" />
            </g>
            {/* Nudo — cruce de los flejes en el frente */}
            <circle cx="95" cy="130" r="7" fill={variant === 'full' ? 'var(--ink)' : color} />
        </svg>
    );
}
